import { Action, createReducer, on } from "@ngrx/store";
import { AppState } from "./app.state";
import {DocumnentTypes, retrieveDocument} from './document-actions';
import * as storage from '../storage';


export const initialDocumentState: AppState = {
    document: storage.getItem('document').document
}

// const _documentReducer = createReducer(initialDocumentState, on(retrieveDocument, (state, action) => {
//     return {
//         ...state,
//         document: action.document
//     }    
// }));

 const _documentReducer = createReducer(initialDocumentState, on(retrieveDocument, (state, action) => ({...state, document: action.document})));

export function documentReducer(state:AppState | undefined, action:Action) : any {
    // switch(action.type) {
    //     case DocumnentTypes.RetrieveDocumentType: return _documentReducer(state, action);
    //     default: return state;
    // }
    return _documentReducer(state, action);
}

export const getDocument = (state:AppState) => {
    console.log('###########state.document##############')
    console.log(state.document)
    console.log('#########################')
    return state.document;
}